import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-bid-box-header',
  templateUrl: './bid-box-header.component.html',
  styleUrls: ['./bid-box-header.component.scss'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    TranslateModule,
    NgClass,
    NgbCollapse,
  ],
})
export class BidBoxHeaderComponent implements OnInit {
  faChevronDown = faChevronDown;

  @Input() isGoldAuction = true;
  @Input() isSuggestedAuction = false;

  isCollapsed = true;
  idsAuction = 'IDS_MEMORABID_AUCTIONS';
  idsWhatIs = 'IDS_MEMORABID_WHAT_IS';
  idsTitleHome = 'IDS_GOLD_DESCRIPTION_TITLE_HOME';
  idsHome = 'IDS_GOLD_DESCRIPTION_HOME';

  constructor() { }

  ngOnInit(): void {
    if(this.isSuggestedAuction) {
      this.idsAuction = "IDS_MEMORABID_INTEREST";
    }
    if(!this.isGoldAuction) {
      this.idsAuction = 'IDS_MARKETPLACE_AUCTIONS';
      this.idsWhatIs = 'IDS_MARKETPLACE_WHAT_IS';
      this.idsTitleHome = 'IDS_MARKETPLACE_DESCRIPTION_TITLE_HOME';
      this.idsHome = 'IDS_MARKETPLACE_DESCRIPTION_HOME';

      if(this.isSuggestedAuction) {
        this.idsAuction = "IDS_MARKETPLACE_INTEREST";
      }
    }
  }

}
